// extracted by mini-css-extract-plugin
export default {"container":"DrawerHeader_container__FOOwg","titleContainer":"DrawerHeader_titleContainer__tk-hl","closeContainer":"DrawerHeader_closeContainer__wPzpa"};